module.exports = __webpack_public_path__ + "static/media/globeIcon.25f157fe.svg";